import type { WaypointEasingMode } from '../types';

export const WAYPOINT_EASING_MODES: WaypointEasingMode[] = [
    'linear',
    'ease-in',
    'ease-out',
    'ease-in-out',
    'smoothstep',
    'smootherstep',
];

export function normalizeWaypointEasing(mode: unknown): WaypointEasingMode {
    return WAYPOINT_EASING_MODES.includes(mode as WaypointEasingMode) ? mode as WaypointEasingMode : 'ease-in-out';
}

export function applyWaypointEasing(t: number, mode: WaypointEasingMode): number {
    const x = Math.max(0, Math.min(1, t));
    switch (mode) {
        case 'linear':
            return x;
        case 'ease-in':
            return x * x;
        case 'ease-out':
            return 1 - (1 - x) * (1 - x);
        case 'smoothstep':
            return x * x * (3 - 2 * x);
        case 'smootherstep':
            return x * x * x * (x * (x * 6 - 15) + 10);
        case 'ease-in-out':
        default:
            return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }
}
